import React from "react";
import "../../main.css";

export default function Faqs() {
    return (
<div>
<div className="p-8">
    <div className=" p-4 py-8 mt-12">
        <h4 className="text-6xl font-bold text-primary tracking-widest uppercase text-center">FAQ</h4>
        <p className="text-center text-primary text-sm mt-2">Here are some of the frequently asked questions</p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 xl:gap-12 px-2 xl:px-12 mt-4">
            <div className="flex space-x-8 mt-8">
                <div>
                    <h4 className="text-xl font-bold font-heading">I Can't See any other User?</h4>
                    <p className="my-2">
                    This Might be a technical Difficulty you can end the call or refresh. In Alpha stage the number of Users
are not large so this will also affect the Matching!
                    </p>
                    {/* <a href="#" className="text-blue-600 hover:text-blue-800 hover:underline capitalize" title="Read More">Read More</a> */}
                </div>
            </div>
            
            <div className="flex space-x-8 mt-8">
                <div>
                    <h4 className="text-xl font-bold font-heading">This site UI is Bad. Can it be better?</h4>
                    <p className=" my-2">
                    Yes We will like your suggestion. You can ping us in the given Chat Icon on bottom left. We are implementing more ways
to Improve the UX.
                    </p>
                    {/* <a href="#" className="text-blue-600 hover:text-blue-800 hover:underline capitalize" title="Read More">Read More</a> */}
                </div>
            </div>

            <div className="flex space-x-8 mt-8">
                <div>
                    <h4 className="text-xl font-bold font-heading">Till when this Site be in Fully launched</h4>
                    <p className="my-2">We are seeking reviews and this is MVP version so if you want a Fully launched then your reviews are welcome.</p>
                    {/* <a href="#" className="text-blue-600 hover:text-blue-800 hover:underline capitalize" title="Read More">Read More</a> */}
                </div>
            </div>

            {/* <div className="flex space-x-8 mt-8">
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01"></path>
                    </svg>
                </div>
                <div>
                    <h4 className="text-xl font-bold text-gray-700">Repudiandae commodi perferendis et itaque?</h4>
                    <p className="text-gray-600 my-2">Lorem ipsum dolor sit amet consectetur adipisicing elit. Quae, dignissimos. Neque eos, dignissimos provident reiciendis debitis repudiandae commodi perferendis et itaque, similique fugiat cumque impedit iusto vitae dolorum. Nostrum, fugit!</p>
                    <a href="#" className="text-blue-600 hover:text-blue-800 hover:underline capitalize" title="Read More">Read More</a>
                </div>
            </div> */}

            {/* <div className="flex space-x-8 mt-8">
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4"></path>
                    </svg>
                </div>
                <div>
                    <h4 className="text-xl font-bold text-gray-700">Similique fugiat cumque?</h4>
                    <p className="text-gray-600 my-2">Lorem ipsum dolor sit amet consectetur adipisicing elit. Quae, dignissimos. Neque eos, dignissimos provident reiciendis debitis repudiandae commodi perferendis et itaque, similique fugiat cumque impedit iusto vitae dolorum. Nostrum, fugit!</p>
                    <a href="#" className="text-blue-600 hover:text-blue-800 hover:underline capitalize" title="Read More">Read More</a>
                </div>
            </div> */}

            {/* <div className="flex space-x-8 mt-8">
                <div>
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 4v16M17 4v16M3 8h4m10 0h4M3 12h18M3 16h4m10 0h4M4 20h16a1 1 0 001-1V5a1 1 0 00-1-1H4a1 1 0 00-1 1v14a1 1 0 001 1z"></path>
                    </svg>
                </div>
                <div>
                    <h4 className="text-xl font-bold text-gray-700">Impedit iusto vitae dolorum, nostrum fugit?</h4>
                    <p className="text-gray-600 my-2">Lorem ipsum dolor sit amet consectetur adipisicing elit. Quae, dignissimos. Neque eos, dignissimos provident reiciendis debitis repudiandae commodi perferendis et itaque, similique fugiat cumque impedit iusto vitae dolorum. Nostrum, fugit!</p>
                    <a href="#" className="text-blue-600 hover:text-blue-800 hover:underline capitalize" title="Read More">Read More</a>
                </div>
            </div> */}
        </div>
    </div>
</div>
    </div>
    )
}